import http from '@/http-common';
import { getPagesCounter, getActualDateInDatetime } from '@/services/utils';

class genericDataService {
  // Auth
  logIn (data) {
    return http.post('/jwt', data)
  }

  getPage (tableName, page, params = null) {
    let url = `/records/${tableName}?page=${page}`
    if (params) {
      url += params
    }
    return http.get(url)
  }

  async getPeripheralsList(page = 1, order = 'desc') {
    return http.get(`/records/peripherals?page=${page}&order=created_at,${order}`)
  }
  async getPeripheryItem (id) {
    return http.get(`/records/peripherals/${id}`)
  }
  async submitPeriphery(body) {
    body.type = 'periphery'
    body.data.created_at = getActualDateInDatetime()
    return http.post('/stock_component', body)
  }
  async updatePeriphery(body) {
    body.type = 'periphery'
    body.data.updated_at = getActualDateInDatetime()
    return http.put(`/stock_component`, body)
  }

  getDetailList(page = 1, order = 'desc') {
    return http.get(`/records/details?page=${page}&order=created_at,${order}`)
  }
  submitDetail(body) {
    body.type = 'detail'
    body.data.created_at = getActualDateInDatetime()
    return http.post('/stock_component', body)
  }
  updateDetail(body) {
    body.type = 'detail'
    body.data.updated_at = getActualDateInDatetime()
    return http.put(`/stock_component`, body)
  }
  getDetailItem (id) {
    return http.get(`/records/details/${id}`)
  }

  // Платы
  async getAllBoardDescendants(id) {
    const params = `?filter=parent_id,eq,${id}`;
    const url = `${process.env.BACKEND_URL}records/circuit_boards${params}`;
    return await http.get(url);
  }
  async deleteAllBoardDescendants(boardId) {
    const data = {
      board_id: boardId,
    }
    const url = '/board_descendants'
    return await http.delete(url, { data })
  }
  getBoardList(page = 1, order = 'desc') {
    return http.get(`/records/circuit_boards?page=${page}&order=created_at,${order}`)
  }
  submitBoard(body) {
    body.type = 'circuitBoard'
    body.data.created_at = getActualDateInDatetime()
    return http.post('/stock_component', body)
  }
  updateBoard(body) {
    body.type = 'circuitBoard'
    body.data.updated_at = getActualDateInDatetime()
    return http.put('/stock_component', body)
  }
  getBoardItem (id) {
    return http.get(`/records/circuit_boards/${id}`)
  }

  // Проекты
  getProjectList(page = 1, order = 'desc') {
    return http.get(`/records/projects_scoreboards?page=${page}&order=created_at,${order}`)
  }
  submitProject (data) {
    data.created_at = getActualDateInDatetime()
    return http.post('/records/projects_scoreboards', data)
  }
  updateProject (data, id) {
    data.updated_at = getActualDateInDatetime()
    return http.put(`/records/projects_scoreboards/${id}`, data)
  }
  getProjectItem (id) {
    return http.get(`/records/projects_scoreboards/${id}`)
  }

  // Наряд-заказы
  getOrderList(page = 1, order = 'desc') {
    const url = `/records/purchase_orders?page=${page}`
      + `&join=clients&order=created_at,${order}&exclude=`
      + `projects_data,additional_peripherals_data`;
    return http.get(url);
  }
  submitOrder (data) {
    data.created_at = getActualDateInDatetime()
    return http.post('/records/purchase_orders', data)
  }
  updateOrder (data, id) {
    data.updated_at = getActualDateInDatetime()
    return http.put(`/records/purchase_orders/${id}`, data)
  }
  getOrderItem (id) {
    return http.get(`/records/purchase_orders/${id}?join=clients`)
  }

  // Провайдеры
  getProviderList(page = 1, order = 'desc') {
    return http.get(`/records/providers?page=${page}&order=created_at,${order}`)
  }
  submitProvider (data) {
    return http.post('/records/providers', data)
  }
  updateProvider (data, id) {
    return http.put(`/records/providers/${id}`, data)
  }
  getProviderItem (id) {
    return http.get(`/records/providers/${id}`)
  }

  // Клиенты
  getClientList(page = 1, order = 'desc') {
    return http.get(`/records/clients?page=${page}&order=created_at,${order}`)
  }
  submitClient (data) {
    return http.post('/records/clients', data)
  }
  updateClient (data, id) {
    return http.put(`/records/clients/${id}`, data)
  }
  getClientItem (id) {
    return http.get(`/records/clients/${id}`)
  }

    // Пользователи
    getUserList (page = 1, order = 'desc') {
      return http.get(`/records/users?page=${page}&order=authorization_date,${order}`)
    }
    submitUser (data) {
      return http.post('/users', data)
    }
    updateUser (data) {
      return http.put(`/users`, data)
    }
    getUserItem (id) {
      return http.get(`/records/users/${id}`)
    }

  // Движение по складу
  async getStockMovement(page = 1, inTrashBin = false, order = 'desc') {
    const joins = '?join=providers&join=details&join=circuit_boards'
      + '&join=peripherals&join=purchase_orders';
    const deletedAtFilter = inTrashBin ? 'nis' : 'is';
    const params = `${joins}&order=created_at,${order}&page=${page}&filter=deleted_at,`
      + `${deletedAtFilter},null&exclude=purchase_orders.projects_data,purchase_orders`
      + `.additional_peripherals_data`;

    let url = '/records/stock_movement';
    url += params;

    let results = [];
    let pagesCounter = 1;
    await http.get(url).then(({ data }) => {
      pagesCounter = getPagesCounter(data.results);
      results = data.records
    });;
    return { results, pagesCounter };
  }
  async doReservation(data) {
    return await http.post('/stock_operations/reservation', data)
  }
  async cancelReservation(purchaseOrderId) {
    const data = {
      purchase_order: {
        id: purchaseOrderId,
        updated_at: getActualDateInDatetime(),
      },
    };
    return await http.delete('/stock_operations/reservation', { data })
  }
  searchItems (entityName, params) {
    return http.get(`/records/${entityName}`, { params })
  }
  async searchManyParams(entityName, params) {
    return await http.get(`/records/${entityName}?${params}`)
  }
}

export default new genericDataService()



// WEBPACK FOOTER //
// ./src/services/genericDataService.js